import type { Dispatch, SetStateAction } from 'react'

import { PartnerSummaryBlock } from 'clickNgo/entities/partner/ui/partnerSummaryBlock'
import { Translation } from 'cng-common/features/translations'
import { type FinancialMetricMode, MetricModeSwitch } from 'partner360/entities/financialMetricMode'

import { sobActualsModalTranslation } from '../../../translation'

import styles from './SobActualsModalContent.module.scss'

type SobActualsModalHeaderProps = {
  pid: string
  region: string
  country: string
  partnerName: string
  locationId: string
  availableMetricModes: FinancialMetricMode[]
  resolvedMetricMode: FinancialMetricMode
  showOverall: boolean
  shouldShowSobDetails: boolean
  isSobDetailsMandatory: boolean
  onShowOverallChange: Dispatch<SetStateAction<boolean>>
  onShowSobDetailsChange: Dispatch<SetStateAction<boolean>>
  onMetricModeChange: Dispatch<SetStateAction<FinancialMetricMode>>
}

export const SobActualsModalHeader = ({
  pid,
  region,
  country,
  partnerName,
  locationId,
  availableMetricModes,
  resolvedMetricMode,
  showOverall,
  shouldShowSobDetails,
  isSobDetailsMandatory,
  onShowOverallChange,
  onShowSobDetailsChange,
  onMetricModeChange,
}: SobActualsModalHeaderProps) => (
  <div className={styles.header}>
    <PartnerSummaryBlock
      region={region}
      country={country}
      partnerName={partnerName}
      pid={pid}
      locationId={locationId}
    />
    <div className={styles.controls}>
      <label className={styles.overallToggle}>
        <input
          type="checkbox"
          checked={shouldShowSobDetails}
          disabled={isSobDetailsMandatory}
          onChange={(event) => onShowSobDetailsChange(event.target.checked)}
          className={styles.overallToggleInput}
        />
        <span className={styles.overallToggleLabel}>
          <Translation text={sobActualsModalTranslation.showSobDetails} span />
        </span>
      </label>
      <label className={styles.overallToggle}>
        <input
          type="checkbox"
          checked={showOverall}
          onChange={(event) => onShowOverallChange(event.target.checked)}
          className={styles.overallToggleInput}
        />
        <span className={styles.overallToggleLabel}>
          <Translation text={sobActualsModalTranslation.showOverall} span />
        </span>
      </label>
      {showOverall && (
        <MetricModeSwitch
          selectedMode={resolvedMetricMode}
          availableModes={availableMetricModes}
          onModeChange={onMetricModeChange}
        />
      )}
    </div>
  </div>
)
